import React, { useState } from 'react';
import { Drawer, TextField, Button, Separator } from '@ublend-npm/aulaui-next';
import { Image } from '../Image/Image';
import { useAnalytics } from '../../lib/useAnalytics';
import {
  AltTextDrawerContainer,
  CharacterCount,
  Section,
  Heading,
  SubHeading,
  Footer,
  Text,
} from './AltTextDrawer.styled';

type Props = {
  open: boolean;
  altText?: string;
  onClose: () => void;
  src: string;
  onChange: (text: string) => void;
};

export const AltTextDrawer = ({
  open,
  altText,
  onClose,
  src,
  onChange,
}: Props) => {
  const [value, setValue] = useState<string>(altText || '');
  const track = useAnalytics();
  return (
    <Drawer
      open={open}
      onClose={() => {
        track('ALT_TEXT_UPDATE_CANCELLED');
        onClose();
      }}
    >
      <AltTextDrawerContainer data-testid="alt-text-drawer">
        <Section>
          <Heading>Alt text</Heading>
          <Text>
            Write a short description of your image for people who have visual
            impairments and use screen readers.
          </Text>
        </Section>
        <Separator />
        <Section fullHeight>
          <TextField
            id="alt-text"
            label="Alt text"
            multiline
            value={value}
            onChange={(e: any) => {
              setValue(e.target.value.slice(0, 200));
            }}
          />
          <CharacterCount data-testid="alt-text-character-count">
            {value.length} / 200
          </CharacterCount>
          <SubHeading>Your image</SubHeading>
          <Image alt={value} style={{ maxWidth: '100%' }} src={src} />
        </Section>

        <Separator />
        <Footer>
          <Button
            onClick={() => {
              track('ALT_TEXT_UPDATE_CANCELLED');
              onClose();
            }}
          >
            Cancel
          </Button>
          <Button
            disabled={value.trim().length < 1}
            type="primary"
            onClick={() => {
              track('ALT_TEXT_UPDATED');
              onChange(value.trim());
            }}
          >
            Apply changes
          </Button>
        </Footer>
      </AltTextDrawerContainer>
    </Drawer>
  );
};
